import { useMutation } from '@tanstack/react-query'
import { useServer } from 'app/server/context'
import { GenerateFileReportParams } from './shared/types'

export function useGenerateFileReport() {
  const { server } = useServer()
  return useMutation({ mutationFn: generateFileReport })

  async function generateFileReport({
    fileId,
    type,
  }: GenerateFileReportParams) {
    const queryParams = new URLSearchParams()
    if (type) {
      queryParams.append('type', type)
    }
    const url = `/v2/chat/repository/files/${fileId}/acknowledgement_report?${queryParams.toString()}`
    const response = await server.get(url)
    return response
  }
}
